import { reactive } from 'vue';
import { readFilteredPages } from './graphql/readFilteredPages';
import { pagination } from './pagination.js';
import { filters, titleFilter } from './filters.js';
import { cache } from './cache.js';
import { filtersToString } from '../utils/filtersToString.js';

export const results = reactive([]);
export const isLoading = reactive({
    loading: true,
});

export async function setResults() {

    isLoading.loading = true;

    // temporarily save existing results...
    const oldResults = JSON.parse(JSON.stringify(results));

    // ...and create an empty array to store our new results...
    const newResults = [];

    // ...before resetting the reactive results array!
    results.splice(0);

    /*
        for the best performance,
        grab cached data first...
    */
    const cacheKey = filtersToString(filters) + '&offset=' + pagination.offset + '&text=' + titleFilter.value;
    const cached = JSON.parse(cache.retrieve(cacheKey));

    if (cached && cached.length) {

        for (let i = 0; i < cached.length; i++) {

            results.push(cached[i]);

        }

    }

    /*
        ...before updating with the latest graphQL response!
    */
    const filteredPages = await readFilteredPages(
        filtersToString(filters),
        pagination.offset,
        titleFilter.value,
    );

    if (oldResults.length && pagination.offset !== 0) {

        for (let i = 0; i < oldResults.length; i++) {

            newResults.push(oldResults[i]);

        }

    }

    if (filteredPages && filteredPages.nodes.length) {

        for (let i = 0; i < filteredPages.nodes.length; i++) {

            newResults.push({
                id: filteredPages.nodes[i].id,
                title: filteredPages.nodes[i].title,
                content: filteredPages.nodes[i].content,
                link: filteredPages.nodes[i].link,
                className: filteredPages.nodes[i].className,
                image: filteredPages.nodes[i].image,
                masterOurCutsImageURL: filteredPages.nodes[i].masterOurCutsImageURL,
                summary: filteredPages.nodes[i].summary,
            });

            if (i === filteredPages.nodes.length - 1) {

                isLoading.loading = false;

            }

        }

    } else {

        isLoading.loading = false;

    }

    results.splice(0);

    for (let i = 0; i < newResults.length; i++) {

        results.push(newResults[i]);

    }

    cache.save(cacheKey, JSON.stringify(results));

    if (filteredPages && filteredPages.pageInfo) {

        pagination.hasNextPage = filteredPages.pageInfo.hasNextPage;

    }

}
